import { render, staticRenderFns } from "./ServiceListing.vue?vue&type=template&id=03488f0a"
import script from "./ServiceListing.vue?vue&type=script&lang=js"
export * from "./ServiceListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports